import { AcquisitionFlow, getAcquisitionFlow } from '../../../utils/acquisition-utils';

const nameErrorsOrder = [
    'firstName',
    'lastName',
    'suffix'
];

const addressErrorsOrder = [
    'mailingAddressLineOne',
    'AddrAndAptNumMatch',
    'mailingAddressCity',
    'mailingAddressState',
    'mailingAddressZipCode',
    'homeAddressLineOne',
    'HomeAddrAndAptNumMatch',
    'homeAddressCity',
    'homeAddressState',
    'homeAddressZipCode'
];

const cardErrorsOrder = [
    'cardDesign',
];

const miscErrorsOrder = [
    'creditProtectionInitials',
    'authorizedUserFirstName',
    'authorizedUserLastName',
    'authorizedUserDob',
    'authorizedUserSpouse',
];

const paPiErrorsOrder = [
    'emailAddress',
    'phoneNumber',
    'ssn',
    'dob',
    'monthlyIncome',
];

const skipPqPiErrorsOrder = [
    'phoneNumber',
    'emailAddress',
    'ssn',
    'dob',
    'monthlyIncome',
];

const pqPiErrorsOrder = [
    'phoneNumber',
    'monthlyIncome',
];

const phaPiErrorsOrder = [
    'ssn',
];

const piErrorsOrder = (flow: AcquisitionFlow) => {
    switch (flow) {
                case AcquisitionFlow.SkipPQ:
                    return skipPqPiErrorsOrder;
                case AcquisitionFlow.PqOfOne:
                case AcquisitionFlow.PQ:
                    return pqPiErrorsOrder;
                case AcquisitionFlow.PHA:
                    return phaPiErrorsOrder;
                case AcquisitionFlow.PA:
                default:
                    return paPiErrorsOrder;
            }
}

export default (
    pushupErrorMessages: Record<string, string>,
): string[] => {
    const flow = getAcquisitionFlow();
    const sortOrder = [
        flow === AcquisitionFlow.SkipPQ ? cardErrorsOrder : [],
        nameErrorsOrder,
        addressErrorsOrder,
        piErrorsOrder(flow),
        flow !== AcquisitionFlow.SkipPQ ? cardErrorsOrder : [],
        miscErrorsOrder,
    ].flat();
    const sortedMessages = [];

    sortOrder.forEach(key => {
        const message = pushupErrorMessages[key];
        if (message) {
            sortedMessages.push(message);
        }
    });
    return sortedMessages;
}